<template>
  <el-dialog
    title="任务详情 - 数据集状态"
    :visible="dialogVisible"
    width="1000px"
    :close-on-click-modal="false"
    @close="hide()"
    center
  >
    <div class="task-info">
      <div class="info-item">
        <span class="label">任务编号：</span>
        <span class="value">#{{taskInfo.id}}</span>
      </div>
      <div class="info-item">
        <span class="label">创建时间：</span>
        <span class="value">{{taskInfo.createTime | parseTime()}}</span>
      </div>
      <div class="info-item">
        <span class="label">状态：</span>
        <span class="value">{{getStatus(taskInfo.state)}}</span>
      </div>
      <div class="info-item">
        <span class="label">操作员：</span>
        <span class="value">{{taskInfo.adminName}}</span>
      </div>
    </div>
    <el-table
      class="tableBox W100"
      v-loading="loading"
      :data="tableData"
      stripe
      max-height="420"
      header-cell-class-name="headerTh"
      style="width: 100%">
      <el-table-column
        align="center"
        type="index"
        label="序号">
      </el-table-column>
      <el-table-column
        align="center"
        prop="apkName"
        label="应用名称">
      </el-table-column>
      <el-table-column
        align="center"
        prop="apkPackage"
        label="应用包名">
      </el-table-column>
      <el-table-column
        align="center"
        label="OPPO">
        <template slot-scope="scope">
          <span>{{getPlatformStatus(getMemberStatus(scope.row, 'OPPO'))}}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="vivo">
        <template slot-scope="scope">
          <span>{{getPlatformStatus(getMemberStatus(scope.row, 'vivo'))}}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="小米">
        <template slot-scope="scope">
          <span>{{getPlatformStatus(getMemberStatus(scope.row, 'xiaomi'))}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <div class="summary">
        共 <span class="count total">{{total}}</span> 条数据
        成功 <span class="count success">{{successCount}}</span>
        失败 <span class="count fail">{{failCount}}</span>
        处理中 <span class="count processing">{{processingCount}}</span>
      </div>
      <div
        class="btn export"
        v-auth="permission.IMPORT_TASK_DOWNLOAD"
        @click="exportData()">
        导出数据
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'dataSetStatus',
    data() {
      return {
        //显示dialog
        dialogVisible: false,
        //任务信息
        taskInfo: {},
        //数据集列表
        tableData: [],
        //数据集统计
        total: 0,
        successCount: 0,
        failCount: 0,
        processingCount: 0,
        //表格loading
        loading: false,
      }
    },
    methods: {
      //展示dialog，供父组件调用
      show(row) {
        this.dialogVisible = true;
        this.taskInfo = row || {};
        this.loadData();
      },
      //关闭dialog
      hide() {
        this.dialogVisible = false;
      },
      //查询数据集状态
      loadData() {
        this.loading = true
        // 一次性拉取全部数据集（弹窗内不分页）
        this.$apis.importTaskServer.queryDetail({
          taskId: this.taskInfo.id,
          page: 1,
          perPage: 10000,
        }).then(res => {
          this.loading = false
          if (res['code'] == 0 && res.data) {
            this.tableData = res.data.data || [];
            this.taskInfo = res.data.taskInfo || this.taskInfo;
            this.total = this.taskInfo.totalCount || 0;
            this.successCount = this.taskInfo.successCount || 0;
            this.failCount = this.taskInfo.failCount || 0;
            this.processingCount = this.total - this.successCount - this.failCount;
          } else {
            this.tableData = [];
            this.total = 0;
            this.successCount = 0;
            this.failCount = 0;
            this.processingCount = 0;
          }
        })
      },
      //转换任务状态
      getStatus(data) {
        switch (data) {
          case 1:
            return '待开始'
          case 2:
            return '进行中'
          case 3:
            return '已完成'
          case 4:
            return '失败'
          default:
            return '-'
        }
      },
      //获取厂商处理状态（memberState）
      getMemberStatus(row, member) {
        return row.memberState && row.memberState[member] ? row.memberState[member].state : ''
      },
      //转换厂商处理状态
      getPlatformStatus(data) {
        switch (data) {
          case 1:
            return '待处理'
          case 2:
            return '成功'
          case 3:
            return '失败'
          default:
            return '-'
        }
      },
      //导出数据
      exportData() {
        let formData = new FormData();
        formData.append('taskId', this.taskInfo.id);
        formData.append('token', localStorage.getItem('Token'));
        this.$apis.importTaskServer.exportApk(formData).then(res => {
          if (res['code'] == 0 && res.data.link) {
            window.location.href = res.data.link;
          }
        })
      },
    }
  }
</script>

<style scoped lang="scss">
.task-info {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #f5f7fa;
  border-radius: 5px;
  .info-item {
    width: 50%;
    line-height: 30px;
    font-size: 14px;
    color: #444;
    .label {
      color: #888;
    }
  }
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  .summary {
    line-height: 38px;
    font-size: 14px;
    color: #444;
    .count {
      font-weight: bold;
    }
    .success {
      color: #67C23A;
    }
    .fail {
      color: #F56C6C;
    }
    .processing {
      color: #E6A23C;
    }
  }
  .btn {
    width: 120px;
    height: 38px;
    border-radius: 5px;
    text-align: center;
    line-height: 38px;
    font-size: 16px;
    color: #fff;
    background: #27252B;
    cursor: pointer;
    &:hover {
      background: #444;
    }
  }
}
</style>
